/**
 *
 * @module
 *
 */
const DEM_MODELS = [
	{
		id: 'landmark_neom',
		title: 'منطقة في نيوم',
		description: "في تاريخ ٦ أبريل ٢٠٢٢، التقط القمر الصناعي التابع لمركز الاستشعار عن بُعد بمدينة الملك عبدالعزيز للعلوم والتقنية KACST، .هذه الصورة لمنطقة في نيوم، ونيوم هي مشروع سعودي لمدينة مخطط لبنائها عابرة للحدود، يقع المشروع في أقصى شمال غرب السعودية (منطقة تبوك)، يحده البحر الأحمر من الغرب على امتداد ٤٦٠ كم، وتقع المنطقة شمال غرب المملكة، على مساحة ٢٦.٥ ألف كيلو متر مربع، وتطل من الشمال والغرب على البحر الأحمر و خليج العقبة بطول ٤٦٨ كيلو متراً، ويحيط بها من الشرق جبال بارتفاع ٢٥٠٠ متر، ويسمح موقع المشروع بين القارات الثلاث لـ٧٠ في المائة من سكان العالم للوصول إلى الموقع خلال ثماني ساعات كحد أقصى.",
		thumbSrc: 'assets/ce2s2_models/neom/overlay.png',
		url: 'assets/ce2s2_models/neom/In_Neom.glb',

		// Bounding box
		north_boundary:	28.563066893000002,
		south_boundary: 28.489013894,
		east_boundary: 35.531271717,
		west_boundary:35.421547381,
		center: '28.574290408519893, 35.47667485679716',

		// Fallback placement if boundaries are not available
		latLng: [28.574290408519893 , 35.47667485679716],

		// Optional camera hints
		distance_from_poi: 3.0,
		zoomFactor: -0.6,

		// Model placement tweaks
		// Altitude in km
		height: 0.8,
		// Model larger scale for visibility.
		scale: 0.00115,
		// Tilt around local axes (degrees).
		tiltDegreesX: -10,
		tiltDegreesY: -10,
		tiltDegreesZ: -20,
		// Flip model axes if the DEM appears mirrored.
		flipX: true,
		flipZ: true,
		// Manual alignment tuning (lat/lon degrees).
		tuning: {
			// Shift model and bounds together.
			offset: [0.06, -0.00002],
			// Scale bounds around center.
			boundsScale: 0.25
		},
		// Vertical exaggeration applied to up axis
		verticalExaggeration: 1,
		// Extents radius for visibility
		extentsRadius: 10
	},
	{
		id: 'waahbah_crater',
		title: 'فوهة الوعبة',
		description: "في تاريخ ٢٠ مايو ٢٠٢٠، التقط القمر الصناعي التابع للمركز الوطني للإستشعار عن بُعد بمدينة الملك عبدالعزيز للعلوم والتقنية KACST ، هذه الصورة لفوهة الوعبة. وهي حفرة عميقة في الأرض بقطر دائري يبلغ 3 كيلومترات وبعمق ٣٨٠ مترا، وهي الأكبر من نوعها في الشرق الأوسط. تقع على بعد ٢٥٤ كم من مدينة الطائف. يكسو وسط الفوهة طبقة ملحية بيضاء اللون ويعتقد أن سبب تكونها يرجع إلى أن مياه الأمطار تتجمع في قاع الفوهة مكونة بحيرة صغيرة ضحلة لاتتسرب إلى باطن الأرض. يعتقد بعض الباحثين أنها نتيجة انفجار بركاني كبير فيما يرجح البعض الأخر نتجت عن سقوط نيزك، لكن لا يوجد اثبات لذلك.",
		thumbSrc: 'assets/ce2s2_models/waahbah_crater/فوهة بركان او ضربة نيزك100-18052020.jpg',
		url: 'assets/ce2s2_models/waahbah_crater/waahbah_Crater.glb',

		// Bounding box
		north_boundary: 27.230396232,
		south_boundary: 27.157899733,
		east_boundary: 37.644375803,
		west_boundary: 37.530281548,
		center: '27.238744089155176, 37.58643693909267',

		// Fallback placement if boundaries are not available
		latLng: [27.238744089155176, 37.58643693909267],

		// Optional camera hints
		distance_from_poi: 2.6,
		zoomFactor: -0.6,

		// Model placement tweaks
		// Altitude in km
		height: 0.8,
		// Model larger scale for visibility.
		scale: 0.00115,
		// Tilt around local axes (degrees).
		tiltDegreesX: -10,
		tiltDegreesY: -10,
		tiltDegreesZ: -20,
		// Flip model axes if the DEM appears mirrored.
		flipX: true,
		flipZ: true,
		// Manual alignment tuning (lat/lon degrees).
		tuning: {
			// Shift model and bounds together.
			offset: [0.06, -0.00002],
			// Scale bounds around center.
			boundsScale: 0.25
		},
		// Vertical exaggeration applied to up axis
		verticalExaggeration: 1,
		// Extents radius for visibility
		extentsRadius: 10
	},
	{
		id: 'wadi_lajab',
		title: 'وادي لُجب بجازان',
		description: "في تاريخ ٥ يوليو ٢٠٢٢، التقط القمر الصناعي التابع لمركز الاستشعار عن بُعد بمدينة الملك عبدالعزيز للعلوم والتقنية KACST، هذه الصورة لوادي لجُب بحازان وهو صدع وانكسار في الجزء الشرقي من جبل القهر التابع لمحافظة الريث التي تقع على بعد 150 كم إلى الشمال الشرقي من مدينة جيزان. يعتبر من أهم المواقع السياحية.",
		thumbSrc: 'assets/ce2s2_models/wadi_lajab/overlay.png',
		url: 'assets/ce2s2_models/wadi_lajab/Wadi_lajab_pro.glb',

		// Bounding box
		north_boundary: 17.689255066,
		south_boundary: 17.528971495,
		east_boundary: 43.045047375,
		west_boundary: 42.827505519,
		center: '17.60726195274149, 42.93266398349822',

		// Fallback placement if boundaries are not available
		latLng: [17.60726195274149, 42.93266398349822],

		// Optional camera hints
		distance_from_poi: 4.0,
		zoomFactor: -0.6,

		// Model placement tweaks
		// Altitude in km
		height: 0.8,
		// Model larger scale for visibility.
		scale: 0.00115,
		// Tilt around local axes (degrees).
		tiltDegreesX: -10,
		tiltDegreesY: -10,
		tiltDegreesZ: -20,
		// Flip model axes if the DEM appears mirrored.
		flipX: true,
		flipZ: true,
		// Manual alignment tuning (lat/lon degrees).
		tuning: {
			// Shift model and bounds together.
			offset: [0.06, -0.00002],
			// Scale bounds around center.
			boundsScale: 0.25
		},
		// Vertical exaggeration applied to up axis
		verticalExaggeration: 1,
		// Extents radius for visibility
		extentsRadius: 10
	},
	{
		id: 'jabal_allawz',
		title: 'جبل اللوز',
		description: "التقط القمر الصناعي التابع لمركز الاستشعار عن بُعد بمدينة الملك عبدالعزيز للعلوم والتقنية (KACST) هذه الصورة لجبل اللوز، الواقع في شمال غرب منطقة تبوك، والذي يُعد من أبرز المرتفعات في المملكة العربية السعودية. يتميز بتضاريسه الجبلية الشاهقة وأجوائه الباردة شتاءً، وقد تكسو قممه الثلوج في بعض المواسم، مما يجعله وجهة طبيعية يقصدها الزوار للاستمتاع بمناظره واستكشاف محيطه.",
		thumbSrc: 'assets/ce2s2_models/jabal_alwaz/overlay.png',
		url: 'assets/ce2s2_models/jabal_alwaz/jabal_alwaz.glb',

		// Bounding box
		north_boundary:	28.563066893000002,
		south_boundary: 28.489013894,
		east_boundary: 35.531271717,
		west_boundary:35.421547381,
		center: '28.574290408519893, 35.47667485679716',

		// Fallback placement if boundaries are not available
		latLng: [28.574290408519893 , 35.47667485679716],

		// Optional camera hints
		distance_from_poi: 3.0,
		zoomFactor: -0.6,

		// Model placement tweaks
		// Altitude in km
		height: 0.8,
		// Model larger scale for visibility.
		scale: 0.00115,
		// Tilt around local axes (degrees).
		tiltDegreesX: -10,
		tiltDegreesY: -10,
		tiltDegreesZ: -20,
		// Flip model axes if the DEM appears mirrored.
		flipX: true,
		flipZ: true,
		// Manual alignment tuning (lat/lon degrees).
		tuning: {
			// Shift model and bounds together.
			offset: [0.06, -0.00002],
			// Scale bounds around center.
			boundsScale: 0.25
		},
		// Vertical exaggeration applied to up axis
		verticalExaggeration: 1,
		// Extents radius for visibility
		extentsRadius: 10
	}
];

const DEFAULT_DEM_MODEL_ID = DEM_MODELS[0]?.id || null;

const getDemModelById = demModelId => DEM_MODELS.find(({ id }) => id === demModelId) || DEM_MODELS[0] || null;

export { DEM_MODELS, DEFAULT_DEM_MODEL_ID, getDemModelById };

export default DEM_MODELS;
